// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-rectangle-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 185px;
    height: 110px;
    margin: 30px auto;
}

.softlite-rectangle-input {
    position: absolute;
    width: 120px;
    text-align: center;
}

.softlite-top-input {
    top: -16px;
    left: 50%;
    transform: translateX(-50%);
}

.softlite-bottom-input {
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
}

.softlite-middle-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}

.softlite-side-input {
    width: 100px;
}

.softlite-left-input {
    left: -34px;
    top: 50%;
    transform: translateY(-50%);
}

.softlite-right-input {
    right: -34px;
    top: 50%;
    transform: translateY(-50%);
}

.softlite-rectangle {
    flex-grow: 1;
    border: 1px solid #000;
    height: 100%;
    margin: 0 15px;
}

.softlite-text-center input{
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/dimensions/dimensions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".softlite-rectangle-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    width: 185px;\r\n    height: 110px;\r\n    margin: 30px auto;\r\n}\r\n\r\n.softlite-rectangle-input {\r\n    position: absolute;\r\n    width: 120px;\r\n    text-align: center;\r\n}\r\n\r\n.softlite-top-input {\r\n    top: -16px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.softlite-bottom-input {\r\n    bottom: -30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.softlite-middle-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.softlite-side-input {\r\n    width: 100px;\r\n}\r\n\r\n.softlite-left-input {\r\n    left: -34px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.softlite-right-input {\r\n    right: -34px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.softlite-rectangle {\r\n    flex-grow: 1;\r\n    border: 1px solid #000;\r\n    height: 100%;\r\n    margin: 0 15px;\r\n}\r\n\r\n.softlite-text-center input{\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
